import React, { useEffect } from "react";
import { Box, TextField, Typography, Button } from "@mui/material";
import { Controller, useForm } from "react-hook-form";

export interface FilterCuposProductoFormData {
  codigoProducto: string;
  nombreProducto: string;
  tipoProducto: string;
}

interface FilterCuposProductoProps {
  searchFilters?: FilterCuposProductoFormData | null;
  onCancel?: () => void;
  onFilter?: (data: FilterCuposProductoFormData) => void;
}

const FilterCuposProducto = ({
  searchFilters,
  onCancel,
  onFilter,
}: FilterCuposProductoProps) => {
  const { handleSubmit, control, reset } = useForm<FilterCuposProductoFormData>(
    {
      defaultValues: {
        codigoProducto: "",
        nombreProducto: "",
        tipoProducto: "",
      },
    },
  );

  useEffect(() => {
    if (searchFilters === null) {
      reset({
        codigoProducto: "",
        nombreProducto: "",
        tipoProducto: "",
      });
      return;
    }
    if (searchFilters) {
      reset({
        codigoProducto: searchFilters.codigoProducto || "",
        nombreProducto: searchFilters.nombreProducto || "",
        tipoProducto: searchFilters.tipoProducto || "",
      });
    }
  }, [searchFilters, reset]);

  const onSubmitHandler = (data: FilterCuposProductoFormData) => {
    onFilter?.(data);
  };

  const handleLimpiar = () => {
    reset({
      codigoProducto: "",
      nombreProducto: "",
      tipoProducto: "",
    });
    onCancel?.();
  };

  return (
    <form onSubmit={handleSubmit(onSubmitHandler)}>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          alignItems: "flex-end",
          mb: 3,
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ flex: "1 1 200px", minWidth: 180 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            Código de producto
          </Typography>
          <Controller
            control={control}
            name="codigoProducto"
            render={({ field }) => (
              <TextField
                {...field}
                size="small"
                fullWidth
                placeholder="Ej. PRD-001"
              />
            )}
          />
        </Box>
        <Box sx={{ flex: "1 1 200px", minWidth: 180 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            Nombre de producto
          </Typography>
          <Controller
            control={control}
            name="nombreProducto"
            render={({ field }) => (
              <TextField
                {...field}
                size="small"
                fullWidth
                placeholder="Buscar por nombre"
              />
            )}
          />
        </Box>
        <Box sx={{ flex: "1 1 200px", minWidth: 180 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            Tipo de producto
          </Typography>
          <Controller
            control={control}
            name="tipoProducto"
            render={({ field }) => (
              <TextField
                {...field}
                size="small"
                fullWidth
                placeholder="Ej. Mayorista"
              />
            )}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: 1,
            flexWrap: "wrap",
            justifyContent: "flex-end",
          }}
        >
          <Button variant="outlined" color="primary" onClick={handleLimpiar}>
            Limpiar
          </Button>
          <Button type="submit" variant="contained" color="primary">
            Buscar
          </Button>
        </Box>
      </Box>
    </form>
  );
};

export default FilterCuposProducto;
